import { Maybe, PostTerminationPaymentAmountType } from "@oysterhr/schema"
import { RestrictiveCovenantsRulesFragment } from "~/gql/graphql"
import {
  getSingleRelevantPaymentRule,
  parseAmountType,
  parsePaymentFrequency,
} from "../helpers/parseRules"
import { ClientPaymentType, RestrictiveCovenantsFormValues } from "../types"

export const getStatutoryPaymentValue = ({
  currentValues,
  knowledgeBase,
}: {
  currentValues?: RestrictiveCovenantsFormValues
  knowledgeBase: RestrictiveCovenantsRulesFragment | undefined
}) => {
  const paymentRule =
    knowledgeBase && currentValues
      ? getSingleRelevantPaymentRule({
          knowledgeBase,
          currentValues,
        })
      : undefined

  const amountType = parseAmountType({ currentValues, knowledgeBase })
  const paymentFrequency = parsePaymentFrequency({ currentValues, knowledgeBase })
  /**
   * Prefill payment fields with statutory amount:
   * - When amountStatutory_* is present and amountRecommended_* or amountTopOfMarket_* are blank,
   *      having the statutory component displayed instead of the form (statutoryPaymentVisible = true).
   * - When amountStatutory_* is present and amountRecommended_* or amountTopOfMarket_* are present.
   */
  const statutoryPaymentValue: Maybe<ClientPaymentType> = paymentRule?.amountStatutory
    ? {
        amountType: amountType.requiredAmountType,
        paymentFrequency: paymentFrequency.requiredPaymentFrequency,
        amountFixed:
          amountType.requiredAmountType === PostTerminationPaymentAmountType.Flat
            ? paymentRule?.amountStatutory?.flat?.subunitToUnit
            : undefined,
        amountPercentage:
          amountType.requiredAmountType === PostTerminationPaymentAmountType.PercentageMonthlyGross
            ? paymentRule?.amountStatutory?.percentage || undefined
            : undefined,
      }
    : null

  return statutoryPaymentValue
}
